import {
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  progress: {
    margin: '48px auto 0 auto',
    display: 'block',
  },
});

const LoadingPage = () => {
  const classes = useStyles();

  return (<CircularProgress className={classes.progress}/>);
};

export default LoadingPage;